<template>
    <div class="login-container">
      <div class="login-box">
        <div class="login-text" v-if="typeView != 2 && typeView != 3">
          <a href="javascript:;" :class="typeView == 0 ? 'active' : ''" @click="handleTab(0)">登录</a>
          <b>·</b>
          <a href="javascript:;" :class="typeView == 1 ? 'active' : ''" @click="handleTab(1)">注册</a>
        </div>
        <!-- 登录模块 -->
        <div class="right-content" v-show="typeView == 0">
          <div class="input-box">

            <input
              autocomplete="off"
              type="text"
              class="input"
              v-model="formLogin.userName"
              placeholder="请输入登录手机号(10位)"
            />
            <input
              autocomplete="off"
              type="password"
              class="input"
              v-model="formLogin.userPwd"
              maxlength="20"
              @keyup.enter="login"
              placeholder="请输入登录密码"
            />
          </div>
          <a-button
            class="loginBtn"
            type="primary"
            :disabled="isDisabled"
            :loading="isLoading"
            @click.stop="login">
            立即登录
          </a-button>

          <div class="option">
            <a-checkbox class="remember" v-model="checked" @change="checkChange">
              <span class="checked">保持登录</span>
            </a-checkbox>
            <span class="forget-pwd" @click.stop="forgetPwd">忘记密码?</span>
          </div>
        </div>

        <!-- 注册模块 -->
        <div class="right-content" v-show="typeView == 1">
          <div class="input-box">
            <input
              autocomplete="off"
              type="text"
              class="input"
              v-model="formRegister.userName"
              placeholder="请输入注册手机号"
            />
            <input
              autocomplete="off"
              type="password"
              class="input"
              v-model="formRegister.userPwd"
              maxlength="20"
              @keyup.enter="register"
              placeholder="请输入密码"
            />
            <input
              autocomplete="off"
              type="password"
              class="input"
              v-model="formRegister.userPwd2"
              maxlength="20"
              @keyup.enter="register"
              placeholder="请再次确认密码"
            />
          </div>
          <a-button 
            class="loginBtn" 
            type="primary" 
            :disabled="isRegAble" 
            :loading="isLoading" 
            @click.stop="register">
            立即注册
          </a-button>
          <div class="option">
            <a-checkbox class="remember" v-model="read" @change="checkRead">
              <span class="checked">我已阅读并接受</span>
            </a-checkbox>
            <label class="protocol" @click.stop="showPrivacy">《用户协议》</label>
          </div> 
        </div>

        <!-- Privacy -->
        <div class="right-content" style="position:relative;" v-show="typeView == 3">
          <div style="position:absolute;right:15px;top:15px;z-index:10;" @click="typeView=1">
          <closeCircleOutlined style="color:#4981f2;" />
          </div>
          <Privacy />
        </div>

        <!-- 忘记密码 -->
        <div class="right-content" v-show="typeView == 2">
          <div class="title">重置密码</div>
          <div class="input-box">
            <input
              autocomplete="off"
              type="text"
              class="input"
              v-model="formReset.userName"
              placeholder="请输入注册时使用的手机号"
            />
            <input
              autocomplete="off"
              type="password"
              class="input"
              v-model="formReset.userPwd"
              maxlength="20"
              @keyup.enter="reset"
              placeholder="请输入密码"
            />
            <input
              autocomplete="off"
              type="password"
              class="input"
              v-model="formReset.userPwd2"
              maxlength="20"
              @keyup.enter="reset"
              placeholder="请再次确认密码"
            />
          </div>
          <a-button 
            class="loginBtn" 
            type="primary" 
            :disabled="isResetAble" 
            :loading="isLoading" 
            @click.stop="resetPwd">
            确认重置
          </a-button>
          <div class="option">
            <span class="goback" @click.stop="selectLogin">返回登录注册</span>
          </div>
        </div> 

      </div>


  </div>
</template>

<script>
	import { onMounted, ref, reactive,inject } from 'vue'
  import Privacy from '@/views/Privacy.vue'
  import { login, register, resetPwd } from '@/utils/api'
	const md5 = require('../utils/md5');

    export default {
		emits: ['hideFooter'],
        components: {Privacy},
    computed: {
      isDisabled() {
        return !(this.formLogin.userName && this.formLogin.userPwd)
      },
      isRegAble() {
        return !(this.formRegister.userName && this.formRegister.userPwd && this.formRegister.userPwd2)
      },
      isResetAble() {
        return !(this.formReset.userName && this.formReset.userPwd && this.formReset.userPwd2)
      }
    },
        methods: {
          // 登录/注册tab切换
          handleTab(type) {
          this.typeView = type;
          this.clearInput();
          },
          clearInput() {
              //必须单个清空，否则破坏其响应性
              this.formLogin.userName = ''
              this.formLogin.userPwd  = ''
              
              this.formRegister.userName = ''
              this.formRegister.userPwd  = ''
              this.formRegister.userPwd2  = ''

              this.formReset.userName = ''
              this.formReset.userPwd  = ''
              this.formReset.userPwd2  = ''
          },
          // 是否勾选记住密码
          checkChange(status) {
          console.log(status);
          this.checked = status;
          },

          // 是否阅读用户协议
          checkRead(status) {
            this.read = status
          },

          //设置cookie通用函数
          //name: cookie name
          //value: cookie value
          //exdays: 过期天数
          setCookie(name, value, exdays){
            var expires = new Date()
            expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000 * exdays)
            document.cookie = name+"="+escape(value)+";expires="+expires.toGMTString()+";path=/"
          },
      

        //检查用户是否选择保持登录状态
        check_user_stay(){
          if (document.cookie.length > 0){
            let c_name = "user_stay"
            let c_start = document.cookie.indexOf(c_name + "=")
            if(c_start != -1){ 
            c_start = c_start + c_name.length + 1
            let c_end = document.cookie.indexOf(";",c_start)
            if(c_end==-1) c_end = document.cookie.length
            let c_value = unescape(document.cookie.substring(c_start, c_end))
            let form = {
                    username: c_value.substring(32),
                    password: c_value.substring(0,32)  //已经是加密的了
                }

            login(form)
                .then(res => {
                    this.isLoading = false
                    if(res.code == 0) {
                      this.clearInput()
                      this.$message.success('登录成功')
                      this.$store.dispatch('userInfo/saveInfo', res.data)
                      this.$router.push('/Categories')
                    }
                })
                .catch(() => {
                    this.$message.error('登录失败，请检查网络是否通畅')
                    this.isLoading = false
                })
            }
          }
        },
            

        //清除cookie
        clearCookie() {
        // 修改值为空，天数为负1天就好了
            this.setCookie('user_stay','',-1)
        },
        login(){
          if(this.isDisabled || this.isLoading){
              return false
          }
          if(!this.Valid.validUserName(this.formLogin.userName)) {
              this.$message.warning('请输入正确10位手机号: 区号+号码',3)
              return false
          }
          if(!this.Valid.validPass(this.formLogin.userPwd)) {
              this.$message.warning('密码应为8到20位字母或数字',3)
              return
          }

          // 判断复选框是否被勾选，勾选则调用配置cookie方法
          if (this.checked) {
              let pass = md5(this.formLogin.userPwd)
              let value = pass + this.formLogin.userName
              this.setCookie('user_stay',value,365)
          } else {
              // 清空Cookie
              this.clearCookie();
          }
          this.isLoading = true
          let form = {
              username: this.formLogin.userName,
              password: md5(this.formLogin.userPwd)  //先加密
          }

          login(form)
          .then(res => {
              this.isLoading = false
              if(res.code == 0) {
                this.clearInput()
                this.$message.success('登录成功')
                this.$store.dispatch('userInfo/saveInfo', res.data)
                this.$router.push('/Categories')
              } else {
                this.$message.error('电话号码和密码不匹配')
              }
          })
          .catch(() => {
              this.$message.error('登录失败，请检查网络是否通畅')
              this.isLoading = false
          })
        },
        register(){
          if(this.isRegAble || this.isLoading){
            return false
          }
          if(!this.read){
            this.$message.warning("请勾选'我已阅读并接受《用户协议》'")
            return false
          }
          if(!this.Valid.validUserName(this.formRegister.userName)) {
              this.$message.warning('请输入正确10位手机号: 区号+号码',3)
              return false
		}
		if(!this.Valid.validPass(this.formRegister.userPwd)) {
			this.$message.warning('密码应为8到20位字母或数字',3)
			return false
		}
		if(this.formRegister.userPwd !== this.formRegister.userPwd2) {
			this.$message.warning('两次密码不一致')
			return false
		}

            this.isLoading = true

            let form = {
              username: this.formRegister.userName,
              password: md5(this.formRegister.userPwd)
            }

            register(form).then(res => {
              console.log('注册===', res)
              this.isLoading = false
              if(res.code == 0){
                this.$message.success('注册成功')
                this.$store.dispatch('userInfo/saveInfo', res.data)
                this.$router.push('/')
              }else{
                this.$message.error(res.msg + '!!')
              }
            }).catch(() =>{
              this.$message.error('注册失败，请检查网络是否通畅')
              this.isLoading = false;
            })
        },

		//重置密码
		resetPwd() {
			if(this.isResetAble || this.isLoading) {
				return false
      }
			if(!this.Valid.validUserName(this.formReset.userName)) {
              this.$message.warning('请输入正确10位手机号: 区号+号码',3)
              return false
			}
			if(!this.Valid.validPass(this.formReset.userPwd)) {
				this.$message.warning('密码应为8到20位字母或数字',3)
				return false
			}
			if(this.formReset.userPwd !== this.formReset.userPwd2) {
				this.$message.warning('两次密码不一致')
				return false
			}
			this.isLoading = true

            let form = {
              username: this.formReset.userName,
              password: md5(this.formReset.userPwd)
            }
			resetPwd(form).then(res =>{
				console.log('重置===', res)
        this.isLoading = false
        this.$message.error(res.msg)
			}).catch(() =>{
              this.$message.error('重置密码失败，请检查网络是否通畅')
              this.isLoading = false;
            })

		},

        // 忘记密码界面
        forgetPwd() {
          this.typeView = 2
          this.clearInput()
        },
        // 返回登录界面
        selectLogin() {
          this.typeView = 0
          this.clearInput()
        },
        //用户协议与隐私政策
        showPrivacy() {
          this.typeView = 3
          console.log(this.typeView)
        }
      },
      setup(props,ctx) {
        const Valid = inject('$Valid')
        var formLogin = reactive({
            userName: '',
            userPwd: '',
        })
        var formRegister = reactive({
            userName: '',
            userPwd: '',
            userPwd2: '',
        })
        var formReset = reactive({
            userName: '',
            userPwd: '',
            userPwd2: '',
        })

        //重置密码提示
        var promptMsg = ref('')
        
        var isLoading  = ref(false)
        //保持登录
        var checked = ref(false)
        //已阅读用户协议
        var read = ref(false)
        var typeView = ref(0)
        onMounted(() => {
          ctx.emit('hideFooter',1)
        })
          
        return {Valid,formLogin,formRegister,formReset,isLoading,typeView,checked,read,promptMsg}
      },
      //选项api才能使用this
      mounted(){
        this.check_user_stay()
      }
	}
</script>

<style lang="scss" scoped>

    .login-container {
        width: 100%;
         margin-top: 10px;

 
  .login-box {
    /*
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    */
    margin-left:auto;
    margin-right:auto;
    box-sizing: border-box;
    text-align: center;
    /*box-shadow: 0 1px 11px rgba(0, 0, 0, 0.3);
    border-radius: 2px;
    */
    /*margin: 100px auto 0;*/
    width: 100%;
    max-width:420px;
    background: #fff;
    padding: 45px 35px;
    .option {
      text-align: left;
      margin-top: 18px;
      .checked {
        padding-left: 5px;
      }
      .forget-pwd, .goback {
        float: right;
        font-size: 14px;
        font-weight: 400;
        color: #4981f2;
        line-height: 20px;
        cursor: pointer;
      }
      .protocol {
        color: #4981f2;
        cursor: pointer;
      }
    }

    .login-text {
      width: 100%;
      text-align: center;
      padding: 0 0 30px;
      font-size: 24px;
      letter-spacing: 1px;
      a {
        padding: 10px;
        color: #969696;
		text-decoration: none;
        &.active {
          font-weight: 600;
          color: rgba(73, 129, 242, 1);
          /*border-bottom: 2px solid rgba(73, 129, 242, 1);*/
        }
        &:hover {
          border-bottom: 2px solid rgba(73, 129, 242, 1);
        }
      }
      b {
        padding: 10px;
      }
    }
    .title {
      font-weight: 600;
      padding: 0 0 30px;
      font-size: 24px;
      letter-spacing: 1px;
      color: rgba(73, 129, 242, 1);
    }

    .input-box {
      .input {
        &:nth-child(1) {
          /*margin-top: 10px;*/
        }
        &:nth-child(2),
        &:nth-child(3) {
          margin-top: 20px;
        }
      }
    }

    .loginBtn {
      width: 100%;
      height: 45px;
      margin-top: 40px;
      font-size: 15px;
    }

    .input {
      padding: 10px 0px;
      font-size: 15px;
      width: 350px;
      color: #2c2e33;
      outline: none; // 去除选中状态边框
      border: 1px solid #fff;
      border-bottom-color: #e7e7e7;
      background-color: rgba(0, 0, 0, 0); // 透明背景
    }

    input:focus {
      border-bottom-color: #0f52e0;
      outline: none;
    }
    .button {
      line-height: 45px;
      cursor: pointer;
      margin-top: 50px;
      border: none;
      outline: none;
      height: 45px;
      width: 350px;
      background: rgba(216, 216, 216, 1);
      border-radius: 2px;
      color: white;
      font-size: 15px;
    }
  }

  // 滚动条样式
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
  }

  ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(0, 0, 0, 0.4);
  }

  //设置更改input 默认颜色
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #bebebe;
    font-size: 16px;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #bebebe;
    font-size: 16px;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #bebebe;
    font-size: 16px;
  }

  input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 1) inset;
    -webkit-box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 1) inset;
    -webkit-text-fill-color: #2c2e33;
  }

  .ivu-checkbox-wrapper {
    margin-right: 0;
  }

}
</style>